export default {
  contratoErrors () {
    const errors = []
    if (!this.$v.contrato.$dirty) return errors
    !this.$v.contrato.required && errors.push('Contrato é obrigatório!')
    !this.$v.contrato.isValidContrato && errors.push('Tipo de contrato já adicionado')
    return errors
  },
  payIntervalTypeErrors () {
    const errors = []
    if (!this.$v.payIntervalType.$dirty) return errors
    !this.$v.payIntervalType.required && errors.push('Tipo é obrigatório!')
    return errors
  },
  payIntervalQtyErrors () {
    const errors = []
    if (!this.$v.payIntervalQty.$dirty) return errors
    !this.$v.payIntervalQty.required && errors.push('Quantidade é obrigatório!')
    !this.$v.payIntervalQty.minValue && errors.push('Valor mínimo é inválido!')
    return errors
  },
}